import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { memo } from 'react';
import { useChartData } from '../../../context/ChartContext';
import useSpectrum from '../../../hooks/useSpectrum';
import { assert } from '../../../utility/assert';
import { DraggableStructure } from './DraggableStructure';
export function FloatMoleculeStructuresInner(props) {
    const { zones, ranges, moleculesView, molecules, activeTab, displayerMode } = props;
    const floatingMolecules = Object.entries(moleculesView);
    if (floatingMolecules.length === 0)
        return null;
    return (_jsx(_Fragment, { children: floatingMolecules
            .filter(([, view]) => view.floating.visible)
            .map(([id, moleculeView], index) => {
            const molecule = molecules.find((m) => m.id === id);
            assert(molecule !== undefined, 'molecule should be defined');
            return (_jsx(DraggableStructure, { zones,
                ranges,
                activeTab,
                displayerMode,
                moleculeView,
                molecule,
                index }, id));
        }) }));
}
const MemoizedFloatMoleculeStructures = memo(FloatMoleculeStructuresInner);
const emptyData = { ranges: {}, zones: {} };
export default function FloatMoleculeStructures() {
    const { molecules, displayerMode, view: { molecules: moleculesView, spectra: { activeTab }, }, } = useChartData();
    const data = useSpectrum(emptyData);
    const ranges = data?.ranges || {};
    const zones = data?.zones || {};
    return (_jsx(MemoizedFloatMoleculeStructures, { moleculesView,
        molecules,
        displayerMode,
        activeTab,
        ranges,
        zones }));
}
